import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, TextInput } from "@gravity-ui/uikit";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useGetSportsQuery } from "@/store/api";
import { debounce } from "@/tools/debounce";
import { useSetPageData } from "@/tools/hooks";
export var SportListPage = function () {
    var _a;
    var _b = useState(""), searchQuery = _b[0], setSearchQuery = _b[1];
    var debouncedSearch = debounce(setSearchQuery, 500);
    var navigate = useNavigate();
    /** Поле поиска */
    var searchChangeHandler = function (value) {
        // value.length > 2 &&
        debouncedSearch(value);
    };
    var sportListGetState = useGetSportsQuery({ text: searchQuery });
    useSetPageData({ title: "Вида спорта" });
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: !sportListGetState.isSuccess, loadingKey: "sportsList" }), _jsx(Button, { view: "action", onClick: function () {
                    navigate(RoutesList.Manage.getSportAdd());
                }, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }), _jsx(TextInput, { onUpdate: searchChangeHandler, placeholder: "Поиск", style: { marginBottom: 20 }, size: "xl" }), (_a = sportListGetState.data) === null || _a === void 0 ? void 0 : _a.items.map(function (sport) { return (_jsx("div", { onClick: function () { return navigate(RoutesList.Manage.getSportEdit(sport.id)); }, children: sport.name }, sport.id)); })] }));
};
